export default {
    "TH": {
        "Text": "Total Hip",
        "Parameters": [
            {
                "TH.Approach": {
                    "Text": "Approach",
                    "Items": {
                        "TH.Approach.PosteroLateral": {
                            "Text": "Postero-Lateral"
                        },
                        "TH.Approach.AnteroLateral": {
                            "Text": "Antero-Lateral"
                        },
                        "TH.Approach.DirectAnterior": {
                            "Text": "Direct Anterior"
                        },
                        "TH.Approach.DirectSuperior": {
                            "Text": "Direct Superior"
                        }
                    }
                }
            },
            {
                "TH.AcetabularComponent": {
                    "Text": "Acetabular Component",
                    "Items": {
                        "TH.AcetabularComponent.TridentHemi": {
                            "Text": "Trident Hemi"
                        },
                        "TH.AcetabularComponent.TridentPSL": {
                            "Text": "Trident PSL"
                        },
                        "TH.AcetabularComponent.TridentTritanium": {
                            "Text": "Trident Tritanium"
                        },
                        "TH.AcetabularComponent.TridentIIHemi": {
                            "Text": "Trident II Hemi"
                        },
                        "TH.AcetabularComponent.TridentIIPSL": {
                            "Text": "Trident II PSL"
                        },
                        "TH.AcetabularComponent.TridentIITritanium": {
                            "Text": "Trident II Tritanium"
                        }
                    }
                }
            },
            {
                "TH.FemoralComponent": {
                    "Text": "Femoral Component",
                    "Items": {
                        "TH.FemoralComponent.AccoladeII": {
                            "Text": "Accolade II"
                        },
                        "TH.FemoralComponent.SecurFitAdvanced": {
                            "Text": "Secur-Fit Advanced"
                        },
                        "TH.FemoralComponent.Anato": {
                            "Text": "Anato"
                        },
                        "TH.FemoralComponent.Exeter": {
                            "Text": "Exeter"
                        },
                        "TH.FemoralComponent.ExeterUS": {
                            "Text": "Exeter US"
                        }
                    }
                }
            }
        ],
        "ImplantData": {
            "TH.HeadSize": {
                "Text": "Head Size"
            },
            "TH.CupSize": {
                "Text": "Cup Size"
            },
            "TH.StemSize": {
                "Text": "Stem Size"
            }
        },
        "ValidCombinations": [
            ["TH.Approach.PosteroLateral", "TH.AcetabularComponent.TridentHemi", "TH.FemoralComponent.AccoladeII" ],
            ["TH.Approach.PosteroLateral", "TH.AcetabularComponent.TridentPSL", "TH.FemoralComponent.SecurFitAdvanced" ],
            ["TH.Approach.PosteroLateral", "TH.AcetabularComponent.TridentTritanium", "TH.FemoralComponent.Anato" ],
            ["TH.Approach.PosteroLateral", "TH.AcetabularComponent.TridentIIHemi", "TH.FemoralComponent.Exeter" ],
            ["TH.Approach.PosteroLateral", "TH.AcetabularComponent.TridentIIPSL", "TH.FemoralComponent.ExeterUS" ],
            ["TH.Approach.PosteroLateral", "TH.AcetabularComponent.TridentIITritanium", "TH.FemoralComponent.Insignia" ],
            ["TH.Approach.PosteroLateral", "TH.AcetabularComponent.TridentPSL", "TH.FemoralComponent.AccoladeII" ],
            ["TH.Approach.PosteroLateral", "TH.AcetabularComponent.TridentTritanium", "TH.FemoralComponent.SecurFitAdvanced" ],
            ["TH.Approach.PosteroLateral", "TH.AcetabularComponent.TridentIIHemi", "TH.FemoralComponent.Anato" ],
            ["TH.Approach.PosteroLateral", "TH.AcetabularComponent.TridentIIPSL", "TH.FemoralComponent.Exeter" ],
            ["TH.Approach.PosteroLateral", "TH.AcetabularComponent.TridentIITritanium", "TH.FemoralComponent.ExeterUS" ],
            ["TH.Approach.PosteroLateral", "TH.AcetabularComponent.TridentHemi", "TH.FemoralComponent.ExeterUS" ],
            ["TH.Approach.PosteroLateral", "TH.AcetabularComponent.TridentTritanium", "TH.FemoralComponent.AccoladeII" ],
            ["TH.Approach.PosteroLateral", "TH.AcetabularComponent.TridentIIHemi", "TH.FemoralComponent.SecurFitAdvanced" ],
            ["TH.Approach.PosteroLateral", "TH.AcetabularComponent.TridentIIPSL", "TH.FemoralComponent.Anato" ],
            ["TH.Approach.PosteroLateral", "TH.AcetabularComponent.TridentIITritanium", "TH.FemoralComponent.Exeter" ],
            ["TH.Approach.PosteroLateral", "TH.AcetabularComponent.TridentHemi", "TH.FemoralComponent.Exeter" ],
            ["TH.Approach.PosteroLateral", "TH.AcetabularComponent.TridentPSL", "TH.FemoralComponent.ExeterUS" ],
            ["TH.Approach.PosteroLateral", "TH.AcetabularComponent.TridentIIHemi", "TH.FemoralComponent.AccoladeII" ],
            ["TH.Approach.PosteroLateral", "TH.AcetabularComponent.TridentIIPSL", "TH.FemoralComponent.SecurFitAdvanced" ],
            ["TH.Approach.PosteroLateral", "TH.AcetabularComponent.TridentIITritanium", "TH.FemoralComponent.Anato" ],
            ["TH.Approach.PosteroLateral", "TH.AcetabularComponent.TridentHemi", "TH.FemoralComponent.Anato" ],
            ["TH.Approach.PosteroLateral", "TH.AcetabularComponent.TridentPSL", "TH.FemoralComponent.Exeter" ],
            ["TH.Approach.PosteroLateral", "TH.AcetabularComponent.TridentTritanium", "TH.FemoralComponent.ExeterUS" ],
            ["TH.Approach.PosteroLateral", "TH.AcetabularComponent.TridentIIPSL", "TH.FemoralComponent.AccoladeII" ],
            ["TH.Approach.PosteroLateral", "TH.AcetabularComponent.TridentIITritanium", "TH.FemoralComponent.SecurFitAdvanced" ],
            ["TH.Approach.PosteroLateral", "TH.AcetabularComponent.TridentHemi", "TH.FemoralComponent.SecurFitAdvanced" ],
            ["TH.Approach.PosteroLateral", "TH.AcetabularComponent.TridentPSL", "TH.FemoralComponent.Anato" ],
            ["TH.Approach.PosteroLateral", "TH.AcetabularComponent.TridentTritanium", "TH.FemoralComponent.Exeter" ],
            ["TH.Approach.PosteroLateral", "TH.AcetabularComponent.TridentIIHemi", "TH.FemoralComponent.ExeterUS" ],
            ["TH.Approach.PosteroLateral", "TH.AcetabularComponent.TridentIITritanium", "TH.FemoralComponent.AccoladeII" ],

            ["TH.Approach.AnteroLateral", "TH.AcetabularComponent.TridentHemi", "TH.FemoralComponent.AccoladeII" ],
            ["TH.Approach.AnteroLateral", "TH.AcetabularComponent.TridentPSL", "TH.FemoralComponent.SecurFitAdvanced" ],
            ["TH.Approach.AnteroLateral", "TH.AcetabularComponent.TridentTritanium", "TH.FemoralComponent.Anato" ],
            ["TH.Approach.AnteroLateral", "TH.AcetabularComponent.TridentIIHemi", "TH.FemoralComponent.Exeter" ],
            ["TH.Approach.AnteroLateral", "TH.AcetabularComponent.TridentIIPSL", "TH.FemoralComponent.ExeterUS" ],
            ["TH.Approach.AnteroLateral", "TH.AcetabularComponent.TridentPSL", "TH.FemoralComponent.AccoladeII" ],
            ["TH.Approach.AnteroLateral", "TH.AcetabularComponent.TridentTritanium", "TH.FemoralComponent.SecurFitAdvanced" ],
            ["TH.Approach.AnteroLateral", "TH.AcetabularComponent.TridentIIHemi", "TH.FemoralComponent.Anato" ],
            ["TH.Approach.AnteroLateral", "TH.AcetabularComponent.TridentIIPSL", "TH.FemoralComponent.Exeter" ],
            ["TH.Approach.AnteroLateral", "TH.AcetabularComponent.TridentIITritanium", "TH.FemoralComponent.ExeterUS" ],
            ["TH.Approach.AnteroLateral", "TH.AcetabularComponent.TridentHemi", "TH.FemoralComponent.ExeterUS" ],
            ["TH.Approach.AnteroLateral", "TH.AcetabularComponent.TridentTritanium", "TH.FemoralComponent.AccoladeII" ],
            ["TH.Approach.AnteroLateral", "TH.AcetabularComponent.TridentIIHemi", "TH.FemoralComponent.SecurFitAdvanced" ],
            ["TH.Approach.AnteroLateral", "TH.AcetabularComponent.TridentIIPSL", "TH.FemoralComponent.Anato" ],
            ["TH.Approach.AnteroLateral", "TH.AcetabularComponent.TridentIITritanium", "TH.FemoralComponent.Exeter" ],
            ["TH.Approach.AnteroLateral", "TH.AcetabularComponent.TridentHemi", "TH.FemoralComponent.Exeter" ],
            ["TH.Approach.AnteroLateral", "TH.AcetabularComponent.TridentPSL", "TH.FemoralComponent.ExeterUS" ],
            ["TH.Approach.AnteroLateral", "TH.AcetabularComponent.TridentIIHemi", "TH.FemoralComponent.AccoladeII" ],
            ["TH.Approach.AnteroLateral", "TH.AcetabularComponent.TridentIIPSL", "TH.FemoralComponent.SecurFitAdvanced" ],
            ["TH.Approach.AnteroLateral", "TH.AcetabularComponent.TridentIITritanium", "TH.FemoralComponent.Anato" ],
            ["TH.Approach.AnteroLateral", "TH.AcetabularComponent.TridentHemi", "TH.FemoralComponent.Anato" ],
            ["TH.Approach.AnteroLateral", "TH.AcetabularComponent.TridentPSL", "TH.FemoralComponent.Exeter" ],
            ["TH.Approach.AnteroLateral", "TH.AcetabularComponent.TridentTritanium", "TH.FemoralComponent.ExeterUS" ],
            ["TH.Approach.AnteroLateral", "TH.AcetabularComponent.TridentIIPSL", "TH.FemoralComponent.AccoladeII" ],
            ["TH.Approach.AnteroLateral", "TH.AcetabularComponent.TridentIITritanium", "TH.FemoralComponent.SecurFitAdvanced" ],
            ["TH.Approach.AnteroLateral", "TH.AcetabularComponent.TridentHemi", "TH.FemoralComponent.SecurFitAdvanced" ],
            ["TH.Approach.AnteroLateral", "TH.AcetabularComponent.TridentPSL", "TH.FemoralComponent.Anato" ],
            ["TH.Approach.AnteroLateral", "TH.AcetabularComponent.TridentTritanium", "TH.FemoralComponent.Exeter" ],
            ["TH.Approach.AnteroLateral", "TH.AcetabularComponent.TridentIIHemi", "TH.FemoralComponent.ExeterUS" ],
            ["TH.Approach.AnteroLateral", "TH.AcetabularComponent.TridentIITritanium", "TH.FemoralComponent.AccoladeII" ],

            ["TH.Approach.DirectAnterior", "TH.AcetabularComponent.TridentHemi", "TH.FemoralComponent.AccoladeII" ],
            ["TH.Approach.DirectAnterior", "TH.AcetabularComponent.TridentTritanium", "TH.FemoralComponent.Anato" ],
            ["TH.Approach.DirectAnterior", "TH.AcetabularComponent.TridentPSL", "TH.FemoralComponent.AccoladeII" ],
            ["TH.Approach.DirectAnterior", "TH.AcetabularComponent.TridentIIHemi", "TH.FemoralComponent.Anato" ],
            ["TH.Approach.DirectAnterior", "TH.AcetabularComponent.TridentTritanium", "TH.FemoralComponent.AccoladeII" ],
            ["TH.Approach.DirectAnterior", "TH.AcetabularComponent.TridentIIPSL", "TH.FemoralComponent.Anato" ],
            ["TH.Approach.DirectAnterior", "TH.AcetabularComponent.TridentIIHemi", "TH.FemoralComponent.AccoladeII" ],
            ["TH.Approach.DirectAnterior", "TH.AcetabularComponent.TridentIITritanium", "TH.FemoralComponent.Anato" ],
            ["TH.Approach.DirectAnterior", "TH.AcetabularComponent.TridentHemi", "TH.FemoralComponent.Anato" ],
            ["TH.Approach.DirectAnterior", "TH.AcetabularComponent.TridentIIPSL", "TH.FemoralComponent.AccoladeII" ],
            ["TH.Approach.DirectAnterior", "TH.AcetabularComponent.TridentPSL", "TH.FemoralComponent.Anato" ],
            ["TH.Approach.DirectAnterior", "TH.AcetabularComponent.TridentIITritanium", "TH.FemoralComponent.AccoladeII" ],

            ["TH.Approach.DirectSuperior", "TH.AcetabularComponent.TridentHemi", "TH.FemoralComponent.AccoladeII" ],
            ["TH.Approach.DirectSuperior", "TH.AcetabularComponent.TridentPSL", "TH.FemoralComponent.SecurFitAdvanced" ],
            ["TH.Approach.DirectSuperior", "TH.AcetabularComponent.TridentTritanium", "TH.FemoralComponent.Anato" ],
            ["TH.Approach.DirectSuperior", "TH.AcetabularComponent.TridentPSL", "TH.FemoralComponent.AccoladeII" ],
            ["TH.Approach.DirectSuperior", "TH.AcetabularComponent.TridentTritanium", "TH.FemoralComponent.SecurFitAdvanced" ],
            ["TH.Approach.DirectSuperior", "TH.AcetabularComponent.TridentIIHemi", "TH.FemoralComponent.Anato" ],
            ["TH.Approach.DirectSuperior", "TH.AcetabularComponent.TridentTritanium", "TH.FemoralComponent.AccoladeII" ],
            ["TH.Approach.DirectSuperior", "TH.AcetabularComponent.TridentIIHemi", "TH.FemoralComponent.SecurFitAdvanced" ],
            ["TH.Approach.DirectSuperior", "TH.AcetabularComponent.TridentIIPSL", "TH.FemoralComponent.Anato" ],
            ["TH.Approach.DirectSuperior", "TH.AcetabularComponent.TridentIIHemi", "TH.FemoralComponent.AccoladeII" ],
            ["TH.Approach.DirectSuperior", "TH.AcetabularComponent.TridentIIPSL", "TH.FemoralComponent.SecurFitAdvanced" ],
            ["TH.Approach.DirectSuperior", "TH.AcetabularComponent.TridentIITritanium", "TH.FemoralComponent.Anato" ],
            ["TH.Approach.DirectSuperior", "TH.AcetabularComponent.TridentHemi", "TH.FemoralComponent.Anato" ],
            ["TH.Approach.DirectSuperior", "TH.AcetabularComponent.TridentIIPSL", "TH.FemoralComponent.AccoladeII" ],
            ["TH.Approach.DirectSuperior", "TH.AcetabularComponent.TridentIITritanium", "TH.FemoralComponent.SecurFitAdvanced" ],
            ["TH.Approach.DirectSuperior", "TH.AcetabularComponent.TridentHemi", "TH.FemoralComponent.SecurFitAdvanced" ],
            ["TH.Approach.DirectSuperior", "TH.AcetabularComponent.TridentPSL", "TH.FemoralComponent.Anato" ],
            ["TH.Approach.DirectSuperior", "TH.AcetabularComponent.TridentIITritanium", "TH.FemoralComponent.AccoladeII" ],
        ]
    }
}